import React from "react"
import { Navigate } from "react-router-dom"

import UserManagement from "../pages/UserManagement/index"
import VulnerabilityOverview from "../pages/Vulnerability"
// import AddSiteUrl from "../pages/AddSiteUrl/index"
import StartAScan from "../pages/AddSiteUrl/index"
import UserAccess from "../pages/UserManagement/Access/index"
import ScanList from "../pages/ScanList"


// Landing Page
import MarketingPage from "../pages/Landing/MarketingPage"

// Authentication related pages
import Login from "../pages/Authentication/Login"
import Activation from "../pages/Authentication/activation"
import ResetPwd from "../pages/Authentication/resetPassword"
import Logout from "../pages/Authentication/Logout"
import Register from "../pages/Authentication/Register"
import ForgetPwd from "../pages/Authentication/ForgetPassword"

// Inner Authentication
import Login1 from "../pages/AuthenticationInner/Login"
import Register1 from "../pages/AuthenticationInner/Register"
import Recoverpw from "../pages/AuthenticationInner/Recoverpw"
import LockScreen from "../pages/AuthenticationInner/auth-lock-screen"

import Page403 from "../pages/Extra Pages/pages-403";
import Pages404 from "../pages/Extra Pages/pages-404";
import Pages500 from "../pages/Extra Pages/pages-500";
import SiteUrlSummary from "pages/SiteUrlSummary"
import Accessibility from "pages/Accessibility"
import WebSecurity from "pages/WebSecurity"
import Analytics from "pages/Analytics"
import SearchEngine from "pages/SearchEngine"
import SitePerformance from "pages/SitePerformance"
import MailServer from "pages/MailServer"
import UsWebDesignStd from "pages/Uswds"
import Technology from "pages/Technology"
import { PAGEPATHS } from "components/Common/Constant"
import OrganaizationList from "pages/organaizationList"
import ReferranceTableCreate from "pages/ReferranceFileUpload"
import ComplianceTable from "pages/ComplianceDashboard"
import ScanNameReports from "pages/ComplianceDashboard/scanNameReports"
import IndividualReports from "pages/ComplianceDashboard/individualReports"
import CustomReportLayout from "pages/CustomReportLayout"
import Savedreportlist from "pages/Savedreportlist"
import CustomerDashboard from "pages/CustomDashboard"
import ComprehensiveComplianceDashboard from "pages/ComprehensiveComplianceDashboard";
import FrameworkDetail from "pages/FrameworkDetail";
import DashboardOverview from "pages/DashboardOverview";
import ComplianceMapping from "pages/ComplianceMapping";
import ComplianceReport from "pages/Newdashboard/ComplianceReport"
import Generatetest from "pages/generatetest"
import Dashboard from "pages/Newdashboard/Dashboard";
import FrameworkDetails from "pages/Newdashboard/FrameworkDetails";
import MainDashboard from "pages/MainDashboard";
import OrganizationDashboard from "pages/OrganizationDashboard";
import AIHub from "pages/AIHub";
import Profile from "pages/Profile/Profile";
import Settings from "pages/Settings";
import HelpSupport from "pages/Extra Pages/HelpSupport";
import ComplianceAdmin from "pages/ComplianceAdmin";


// SSP Studio Components
import SSPStudioLayout from "pages/SSPStudio/SSPStudioLayout";
import SSPStudioDashboard from "pages/SSPStudio/Dashboard";
import SSPList from "pages/SSPStudio/SSPList";
import CreateSSP from "pages/SSPStudio/CreateSSP";
import SSPDetail from "pages/SSPStudio/SSPDetail";
import SectionEditor from "pages/SSPStudio/SectionEditor";
import ControlList from "pages/SSPStudio/ControlList";
import ControlDetail from "pages/SSPStudio/ControlDetail";
import TemplateList from "pages/SSPStudio/TemplateList";
import MappingList from "pages/SSPStudio/MappingList";
import ScanUpload from "pages/SSPStudio/ScanUpload";
import FindingsList from "pages/SSPStudio/FindingsList";
import EvidenceLibrary from "pages/SSPStudio/EvidenceLibrary";
import ViewFullSSP from "pages/SSPStudio/ViewFullSSP";

// SSP Studio New (iframe)
import SSPStudioNew from "pages/SSPStudioNew";

import GithubCallback from "../pages/Authentication/GithubCallback"

import LinkedinCallback from "../pages/Authentication/LinkedinCallback"

const superAdminRoutes = [
  { path: PAGEPATHS.Accessmanage, component: <UserAccess /> }
]

const userRoutes = [
  { path: PAGEPATHS.Usermanage, component: <UserManagement /> },
  { path: PAGEPATHS.Scanlist, component: <ScanList /> },
  { path: PAGEPATHS.Landing, component: <MainDashboard /> },
  { path: PAGEPATHS.Vulnerability, component: <VulnerabilityOverview /> },
  { path: `${PAGEPATHS.Vulnerability}/:scanId`, component: <VulnerabilityOverview /> },
  { path: PAGEPATHS.StartAScan, component: <StartAScan /> },
  // { path: PAGEPATHS.Addsiteurl, component: <AddSiteUrl /> },
  { path:`${PAGEPATHS.Siteurlsummary}/:scanId`, component: <SiteUrlSummary /> },
  { path: PAGEPATHS.Accessibility, component: <Accessibility /> },
  { path: `${PAGEPATHS.Accessibility}/:scanId`, component: <Accessibility /> },
  { path: PAGEPATHS.Securitycomp, component: <WebSecurity /> },
  { path: `${PAGEPATHS.Securitycomp}/:scanId`, component: <WebSecurity /> },
  { path: PAGEPATHS.Analytics, component: <Analytics /> },
  { path: PAGEPATHS.Searchengine, component: <SearchEngine /> },
  { path: `${PAGEPATHS.Searchengine}/:scanId`, component: <SearchEngine /> },
  { path: PAGEPATHS.Performance, component: <SitePerformance /> },
  { path: `${PAGEPATHS.Performance}/:scanId`, component: <SitePerformance /> },
  { path: PAGEPATHS.Mailserver, component: <MailServer /> },
  { path: `${PAGEPATHS.Mailserver}/:scanId`, component: <MailServer /> },
  { path: PAGEPATHS.Uswebdesignstd, component: <UsWebDesignStd /> },
  { path: `${PAGEPATHS.Uswebdesignstd}/:scanId`, component: <UsWebDesignStd /> },
  { path: PAGEPATHS.Technologystack, component: <Technology /> },
  { path: PAGEPATHS.editOrganization, component: <OrganaizationList /> },
  { path: PAGEPATHS.referrancrTable, component: <ReferranceTableCreate /> },
  { path: PAGEPATHS.customReportLayout, component: <CustomReportLayout /> },
  { path: PAGEPATHS.Savedreportlist, component: <Savedreportlist /> },
{ path: `${PAGEPATHS.ComplianceDashboard}/:scanId`, component: <ComplianceTable /> },
{ path: `${PAGEPATHS.CustomerDashbord}/:scanId`, component: <CustomerDashboard /> },
{ path: `${PAGEPATHS.ComplianceDashboard}/:scanId/:reportName`, component: <ScanNameReports /> },
{ path: `${PAGEPATHS.ComplianceDashboard}/:scanId/:reportName/:scanName`, component: <IndividualReports /> },
{ path: `${PAGEPATHS.ComprehensiveComplianceDashboard}/:targetId`, component: <ComprehensiveComplianceDashboard /> },
{ path: `${PAGEPATHS.FrameworkDetail}/:frameworkId`, component: <FrameworkDetail /> },
{ path: PAGEPATHS.DashboardOverview, component: <DashboardOverview /> },
{ path: PAGEPATHS.Generatetest, component: <Generatetest /> },
{ path: PAGEPATHS.ComplianceMapping, component: <ComplianceMapping /> },
{ path: PAGEPATHS.Newdashboard, component: <ComplianceReport /> },
{ path: `${PAGEPATHS.Dashboard}/:scanId`, component: <Dashboard /> },
{ path: `${PAGEPATHS.FrameworkDetails}/:scanId/:frameworkId`, component: <FrameworkDetails /> },
{ path: `${PAGEPATHS.OrganizationDashboard}`, component: <OrganizationDashboard /> },
{ path: `${PAGEPATHS.OrganizationDashboard}/:targetId/overview`, component: <OrganizationDashboard />},
{ path: `${PAGEPATHS.AIHub}/:scanId`, component: <AIHub />},

// SSP Studio Routes - Flat routing structure
{ path: PAGEPATHS.SSPStudio, component: <SSPStudioLayout><SSPStudioDashboard /></SSPStudioLayout> },
{ path: `${PAGEPATHS.SSPStudio}/ssps`, component: <SSPStudioLayout><SSPList /></SSPStudioLayout> },
{ path: `${PAGEPATHS.SSPStudio}/create`, component: <SSPStudioLayout><CreateSSP /></SSPStudioLayout> },
{ path: `${PAGEPATHS.SSPStudio}/templates`, component: <SSPStudioLayout><TemplateList /></SSPStudioLayout> },
{ path: `${PAGEPATHS.SSPStudio}/mappings`, component: <SSPStudioLayout><MappingList /></SSPStudioLayout> },
{ path: `${PAGEPATHS.SSPStudio}/scans`, component: <SSPStudioLayout><ScanUpload /></SSPStudioLayout> },
{ path: `${PAGEPATHS.SSPStudio}/findings`, component: <SSPStudioLayout><FindingsList /></SSPStudioLayout> },
{ path: `${PAGEPATHS.SSPStudio}/evidence`, component: <SSPStudioLayout><EvidenceLibrary /></SSPStudioLayout> },
{ path: `${PAGEPATHS.SSPStudio}/ssp/:id`, component: <SSPStudioLayout><SSPDetail /></SSPStudioLayout> },
{ path: `${PAGEPATHS.SSPStudio}/ssp/:id/section/:sectionId`, component: <SSPStudioLayout><SectionEditor /></SSPStudioLayout> },
{ path: `${PAGEPATHS.SSPStudio}/ssp/:id/controls`, component: <SSPStudioLayout><ControlList /></SSPStudioLayout> },
{ path: `${PAGEPATHS.SSPStudio}/ssp/:id/control/:controlId`, component: <SSPStudioLayout><ControlDetail /></SSPStudioLayout> },
{ path: `${PAGEPATHS.SSPStudio}/ssp/:id/view-full`, component: <SSPStudioLayout><ViewFullSSP /></SSPStudioLayout> },

// SSP Studio New (iframe to localhost:3500)
{ path: PAGEPATHS.SSPStudioNew, component: <SSPStudioNew /> },

{ path: PAGEPATHS.Profile, component: <Profile /> },
{ path: "/settings", component: <Settings /> },
{ path: PAGEPATHS.HelpSupport, component: <HelpSupport /> },
{ path: PAGEPATHS.ComplianceAdmin, component: <ComplianceAdmin /> },

]

const authRoutes = [
  // Landing Page
  { path: "/", component: <MarketingPage /> },

  { path: "/logout", component: <Logout /> },
  { path: PAGEPATHS.Login, component: <Login /> },
  { path: PAGEPATHS.Activation, component: <Activation /> },
  { path: PAGEPATHS.Forget, component: <ForgetPwd /> },
  { path: PAGEPATHS.Reset, component: <ResetPwd /> },
  { path: PAGEPATHS.Register, component: <Register /> },

  { path: PAGEPATHS.Notfound, component: <Pages404 /> },
  { path: PAGEPATHS.Internalerror, component: <Pages500 /> },
  { path: PAGEPATHS.Forbidden, component: <Page403 /> },

  { path: "/oauth/github/callback", component: <GithubCallback /> },

  { path: "/oauth/linkedin/callback", component: <LinkedinCallback /> },


  // Authentication Inner
  { path: "/pages-login", component: <Login1 /> },
  { path: "/pages-register", component: <Register1 /> },
  { path: "/page-recoverpw", component: <Recoverpw /> },
  { path: "/auth-lock-screen", component: <LockScreen /> },
]

export { superAdminRoutes, userRoutes, authRoutes }